export default "80f5508c33aca0d1.svg"